import type { PropsWithChildren } from 'react';

import { Text as DesignSystemText } from '@change/ds-core-ui/next';

import { Button } from './Button';

export type TextProps = PropsWithChildren<{
	type: 'text';
	label: string;
	description: string;
	selected: boolean;
	onClick: () => void;
}>;

export function Text({ label, description, selected, onClick }: Omit<TextProps, 'type'>): JSX.Element {
	return (
		<Button selected={selected} onClick={onClick} className="p-7 text-left" data-testid="selection-card-text-button">
			<div className="flex flex-col gap-2">
				<DesignSystemText variant="body" fontWeight="bold">
					{label}
				</DesignSystemText>
				<div className={selected ? 'text-typography-strong' : 'text-typography-weak'}>
					<DesignSystemText variant="body">{description}</DesignSystemText>
				</div>
			</div>
		</Button>
	);
}
